import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import { AutenticacaoService } from '../../autenticacao/autenticacao.service';
import { Usuario } from '../../base/vo/usuario';
import { DadosPrestadorService } from '../../dados-prestador/dados-prestador.service';
import { UsuarioDashboardService } from '../../dashboard/usuario-dashboard/usuario-dashboard.service';
import { URL_INSTITUCIONAL } from '../util/url-util';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  public menuOpen = false;

  usuario = new Usuario;
  urlImagemUsuario = null;
  urlInstitucional = URL_INSTITUCIONAL;
  exibeModalAlterarSenha = false;
  private subscription: Subscription;

  constructor(
    public autenticacaoService: AutenticacaoService,
    public router: Router,
    public usuarioDashboardService: UsuarioDashboardService,
    public dadosPrestadorService: DadosPrestadorService
  ) {
    this.subscription = this.usuarioDashboardService.isImagemPerfilAlterada.subscribe(value => {
      if (value) {
        this.urlImagemUsuario = this.dadosPrestadorService.getImgPerfilCached();
      }
    });
  }

  ngOnInit() {
    this.usuarioDados();

    if (this.autenticacaoService.isPrestador) {
      this.urlImagemUsuario = this.dadosPrestadorService.getImgPerfilCached();
    }

    const alterarSenhaSugerido: boolean = !!localStorage.getItem('alterar-senha-sugerido');

    if (this.usuario.sugereAlterarSenha && !alterarSenhaSugerido) {
      this.exibeModalAlterarSenha = true;
      localStorage.setItem('alterar-senha-sugerido', 'true');
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  usuarioDados() {
    this.usuario = this.autenticacaoService.usuarioLogado;
  }

  sair() {
    this.autenticacaoService.logout();
  }

  alterarSenha() {
    this.exibeModalAlterarSenha = true;
  }

  dadosCadastrais(username) {
    this.router.navigate(['/dados-prestador'], { queryParams: { usuario: username } });
  }

  get isAdmin() {
    return this.autenticacaoService.isAdministrador;
  }

  get isPrestador() {
    return this.autenticacaoService.isPrestador;
  }

  get isMarketing() {
    return this.autenticacaoService.isMarketing;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/base/header/header.component.ts